module.exports = __webpack_public_path__ + "static/media/logo_MSBank.4f311b29.svg";